// Favoritos -- requiere cuenta (JWT), no existe para invitados. Mismo
// patrón que direcciones.js/auth.js: el JWT viaja como `?token=...`.
//
// OJO: GET /favoritos devuelve {items: [{id, nombre, descripcion, precio,
// imagen_url}]} -- ese `id` es el id del PRODUCTO (no un id de fila de
// favorito), y la respuesta no trae `slug` ni `categoria`. Para linkear a
// /personalizar/:slug hay que cruzar estos ids con getProductos()
// (src/api/productos.js) -- así lo hace src/pages/Favoritos.jsx.
import { request } from './ecommerceClient';
import { getStoredAuth } from './auth';

const authParams = () => {
  const { token } = getStoredAuth();
  return token ? { token } : {};
};

export const getFavoritos = async () => {
  const data = await request('/favoritos', { params: authParams() });
  return data.items || [];
};

export const addFavorito = (productoId) =>
  request('/favoritos', {
    method: 'POST',
    params: authParams(),
    body: JSON.stringify({ producto_id: productoId }),
  });

export const removeFavorito = (productoId) =>
  request(`/favoritos/${productoId}`, {
    method: 'DELETE',
    params: authParams(),
  });
